import cn from 'classnames';
import { NumberFormatter } from '@Components/NumberFormatter/NumberFormatter';
import { CellRenderer } from '@Components/StickyTable/StickyTable';

// Log-table totals are type-prefixed strings ("$123", "#4", "%0.9"); the prefix picks the format.
// A % over zero Booked ("%Infinity", "%NaN") shows "—".
export const totalsRenderer: CellRenderer<Element | number | string | undefined> = ({
  data,
  style,
  classes
}) => {
  const type = typeof data === 'string' ? (data.match(/[$%]/)?.[0] ?? '#') : undefined;
  const value = typeof data === 'string' ? parseFloat(data.replace(/[%$#]/g, '')) : NaN;
  return (
    <div style={style} className={cn(classes, 'grand-total-cell')}>
      {type && Number.isFinite(value) ? (
        <NumberFormatter value={value} type={type} />
      ) : (
        type === '%' && '—'
      )}
    </div>
  );
};
